// extracted by mini-css-extract-plugin
module.exports = {"desktop-container":"desktop-container__3KeCH","package-plan-card":"package-plan-card__3BaAt","selected":"selected__-Rsdi"};